var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.chips),function(chip){return _c('v-chip',{key:chip.status,staticClass:"text-uppercase mr-1",attrs:{"label":"","x-small":"","color":chip.color,"text-color":"white"}},[_vm._v(_vm._s(chip.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }